module.exports = __webpack_public_path__ + "img/premium-video-tit.bc839054.png";